<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard p-relative">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{this.title}}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal overflow-hidden"> 
                    <v-row no-gutters>
                        <v-col cols="12" sm="12" md="3">
                            <label class="f-label">{{$t("Год")}}</label>
                        </v-col>
                        <v-col cols="12" sm="12" md="9">
                            <v-select
                                return-object
                                :items="meetingYears"
                                v-model="yearModel"
                                hide-details
                                required
                                :rules="requiredRule.concat(integerNotNull)"
                                outlined
                                dense
                                :menu-props="{ bottom: true, offsetY: true }"
                                append-icon="fas fa-chevron-down"
                            ></v-select>
                        </v-col>
                    </v-row>   

                    <v-row no-gutters>
                        <v-col cols="12" sm="12" md="3">
                            <label class="f-label">{{ $t("Месяц_c") }}</label>
                        </v-col>
                        
                        <v-col cols="12" sm="12" md="9">
                            <div class="more-inputs-in-row">
                                <v-select
                                    v-model="fromMonthModel"
                                    :items="meetingMonths"
                                    :item-text="item => $t(item.Value)"
                                    item-value="id"
                                    hide-details
                                    required
                                    :rules="requiredRule.concat(integerNotNull)"
                                    outlined
                                    dense
                                    append-icon="fas fa-chevron-down"
                                    :menu-props="{ bottom: true, offsetY: true }"
                                >
                                </v-select>
                                <span>{{ $t("по") }}</span>
                                <v-select
                                    v-model="toMonthModel"
                                    :items="meetingMonths"
                                    :item-text="item => $t(item.Value)"
                                    item-value="id"
                                    hide-details
                                    required
                                    :rules="requiredRule.concat(integerNotNull)"
                                    outlined
                                    dense
                                    append-icon="fas fa-chevron-down"
                                    :menu-props="{ bottom: true, offsetY: true }"
                                >
                                </v-select>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                        color="cyan" 
                        text
                        depressed 
                        @click="generate_report" 
                        v-if="ready"
                    >
                        {{$t("сформировать_отчет")}}
                    </v-btn>

                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отмена")}}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { mapGetters } from 'vuex';

export default {
    name: "ReportYearMonthPeriodDlg",
    data () {
        return {
            title: i18n.t("Параметры_отчета"),
            visible: false,
            resolve: null,
            reject: null,
            options: null,
            yearModel: null,
            fromMonthModel: null,
            toMonthModel: null
        }
    },
    computed:{
        ...mapGetters('planner', { meetingMonths: 'getMeetingMonths', meetingYears: 'getMeetingYears'}),
        ...mapGetters({ requiredRule: 'getRequiredRule', integerNotNull: 'getIntegerNotNullRule' }),
        ready() {
            return this.yearModel && this.fromMonthModel && this.toMonthModel && this.toMonthModel >= this.fromMonthModel;
        }
    },
    methods: {
        async open(options = {})
        {
            this.reset();

            this.visible = true;
            this.search = null,
            this.options = Object.assign({
                color: 'grey lighten-3',
                width: 400,
                zIndex: 200,
                noconfirm: false,
            }, options);

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        cancel() {
            this.visible = false;
            if (!this.reject) {  
                new Promise((reject) => {
                    this.reject = reject;
                });
            }
            this.reject({
                isCancelled: true,
                message: "Действие_отменено"
            });
        },
        generate_report() {
            this.visible = false;
            this.resolve({ Year: this.yearModel, FromMonth: this.fromMonthModel, ToMonth: this.toMonthModel });
        },
        reset() {
            this.fromMonthModel = null;
            this.toMonthModel = null;
            this.yearModel = null;
        }
    }
}
</script>